export const Questions = [
    {
        id: 1,
        question:
            "روش کار با پنل پرشین‌سازه و استفاده‌ی درست از امکانات آن را به من یاد بده.",
    },
    {
        id: 2,
        question:
            "نکات استفاده‌ی بهینه و کامل از پلتفرم پرشین‌سازه چیست و چه‌طور بهترین استفاده را از آن ببرم؟",
    },
    {
        id: 3,
        question:
            "سرویس تبلیغات و پیامک پرشین سازه چه امکانات، ویژگی‌ها و برتری‌های نسبت به سایرین دارد و ارزش افزوده‌ی آن چیست؟",
    },
    {
        id: 4,
        question:
            "اشتراک‌های پرشین سازه و تفاوت‌ها و ویژگی‌های آنها را شرح بده.",
    },
    {
        id: 5,
        question:
            "برای برقراری تماس با سازندگان و مشتریان در صنعت ساختمان (تماس سرد و تماس گرم) چه نکاتی را رعایت کنم؟",
    },
    {
        id: 6,
        question:
            "در صنعت ساختمان با چه سیاست و مدلی تخفیف دادن باعث افزایش فروش و سود بیشتر می‌شود؟",
    },
    {
        id: 7,
        question:
            "برای فروش بهتر در صنعت ساختمان چه مهارت‌هایی لازم است و چگونه می‌توانم آنها را به دست آورده و تقویت کنم؟",
    },
    {
        id: 8,
        question:
            "کارگاه‌های آموزشی بازاریابی و فروش پرشین سازه چه کمکی به افزایش فروش من می‌کنند؟",
    },
    {
        id: 9,
        question:
            "برای بازاریابی (مارکتینگ) و برندینگ بهتر در صنعت ساختمان چه راهکارها و روش‌هایی را پیشنهاد می‌کنید؟",
    },
];
